// Identity tag suggestions — ALL OPTIONAL, never required.
// Lovers can also enter free text for cultural/accessibility fields.
export const IDENTITY_TAG_SUGGESTIONS = [
  "LGBTQIA+", "Queer", "Lesbian", "Gay", "Bisexual", "Pansexual", "Asexual",
  "Trans", "Non-binary", "Genderfluid", "Two-Spirit", "Intersex",
  "Multiracial", "Interracial", "Interfaith", "Intercultural",
  "First-Generation / Immigrant", "Alternative Style",
  "Disabled / Chronically ill", "Neurodivergent", "Mixed-Ability Lovers",
  "Body diverse", "Plus-size", "Older couple", "Age Gap Lovers",
  "Ethical Non-Monogamy", "Polyamorous", "Co-Parents", "Blended Family",
];

export const PRONOUN_OPTIONS = [
  "she/her", "he/him", "they/them", "she/they", "he/they", "they/she",
  "they/he", "xe/xem", "ze/zir", "any/all", "ask me", "prefer not to say",
];

export const AGE_RANGES = [
  "18-24", "25-29", "30-34", "35-39", "40-49", "50-59", "60+",
];

export const RELATIONSHIP_TYPES = [
  "Engaged", "Married", "Partnered", "Polyamorous",
  "Dating", "Newlyweds", "Long-term", "Prefer not to say",
];

export const LANGUAGE_SUGGESTIONS = [
  "English", "Spanish", "French", "Mandarin", "Cantonese", "Hindi", "Arabic",
  "Portuguese", "Italian", "German", "Japanese", "Korean", "Tagalog", "Vietnamese",
  "Auslan / ASL", "Hebrew", "Yiddish", "Punjabi", "Urdu", "Other",
];

export const OPPORTUNITY_TYPES = [
  { value: "styled_shoot", label: "Styled Shoot" },
  { value: "editorial", label: "Editorial" },
  { value: "content_day", label: "Content Day" },
  { value: "brand_campaign", label: "Brand Campaign" },
  { value: "ugc", label: "UGC / Social" },
  { value: "elopement_demo", label: "Elopement / Demo Wedding" },
  { value: "other", label: "Other" },
];

export const VENDOR_TYPES = [
  "Photographer", "Videographer", "Wedding Planner", "Florist", "Venue",
  "Stylist", "Hair & Makeup", "Caterer", "DJ / Music", "Officiant",
  "Cake / Dessert", "Stationery", "Content Creator",
  "Magazine / Publication", "Brand", "Other",
];

// Collaboration preference fields — three booleans on the couple profile
export const COLLAB_FIELDS = [
  { key: "open_to_styled_shoots", label: "Styled shoots" },
  { key: "open_to_editorial", label: "Editorial work" },
  { key: "open_to_content_days", label: "Content days" },
];
